export const buildPathWithSearchParams = (
  pathname: string,
  searchParams: URLSearchParams,
): string => {
  const queryString = searchParams.toString();

  return queryString ? `${pathname}?${queryString}` : pathname;
};
